/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import { Button, Input, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';

import InfoView from 'components/common/InfoView';
import { forgotPassword } from 'redux/actions/Auth';
import logo from '../assets/images/kitegateway_icon_dark.png';

const FormItem = Form.Item;

const ForgotPassword = (props) => {
  const dispatch = useDispatch();
  const userEmail = useSelector(({ auth }) => auth.forgotPasswordMail);

  const handleSubmitFailure = (errorInfo) => {
    console.error('Error: ', errorInfo);
  };

  const handleSubmit = (values) => {
    dispatch(forgotPassword(values));
  };

  useEffect(() => {
    if (userEmail) {
      props.history.push('/password-reset');
    }
  }, [userEmail, props.history]);

  return (
    <div className="gx-login-container">
      <div className="gx-login-content">
        <div className="gx-login-header">
          <img src={logo} alt="Kitegateway" style={{ width: '45%' }} title="Kitegateway" />
        </div>
        <div className="gx-mb-4">
          <h2 className="gx-text-primary">Forgot Your Password ?</h2>
          <p>
            Don&apos;t worry. Recovering the password is easy.
            Just tell us the email you have registered with Kitegateway.
          </p>
        </div>
        <Form
          name="forgot-password"
          onFinish={handleSubmit}
          onFinishFailed={handleSubmitFailure}
          className="gx-signin-form gx-form-row0"
        >
          <FormItem name="email" rules={[{ required: true, message: 'Please input your E-mail!' }]}>
            <Input
              className="gx-input-line-height-26"
              type="email"
              placeholder="E-Mail Address"
              autoComplete="off"
            />
          </FormItem>
          <FormItem>
            <Button className="gx-mb-0 enabled" type="primary" htmlType="submit">
              Send
            </Button>
            <div style={{ display: 'flex', marginTop: '7px', float: 'right' }}>
              <Link to="/signin">
                Sign In
                {' '}
                {'→'}
              </Link>
            </div>
          </FormItem>
        </Form>
      </div>
      <InfoView />
    </div>
  );
};

ForgotPassword.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ForgotPassword;
